import { render, staticRenderFns } from "./salary_rule_config.vue?vue&type=template&id=b19acc1a&scoped=true"
import script from "./salary_rule_config.vue?vue&type=script&lang=js"
export * from "./salary_rule_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19acc1a",
  null
  
)

export default component.exports